import { flexCenter } from '@/styles/layout';
import styled from 'styled-components';

export const CheckoutLoaderWrapper = styled.div`
  ${flexCenter};
  position: absolute;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

export const StripeLinkWrapper = styled.a`
  text-decoration: none;
  ${flexCenter};
  column-gap: 4px;
  margin-top: 24px;
  cursor: pointer;
`;
